module.exports = __webpack_public_path__ + "static/img/race-example.50b33ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/race-example.png
// module id = 417
// module chunks = 2